export default "__VITE_ASSET__Bvdei7ol__"